import { render, staticRenderFns } from "./InsuranceCalculationView.vue?vue&type=template&id=2ffc25fe&scoped=true"
import script from "./InsuranceCalculationView.vue?vue&type=script&lang=ts"
export * from "./InsuranceCalculationView.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceCalculationView.vue?vue&type=style&index=0&id=2ffc25fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc25fe",
  null
  
)

export default component.exports